import { Fragment, useEffect } from "react"
import { Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { deleteUser, getUsers } from "../../actions/userActions"
import { clearError, clearUserDeleted } from "../../slices/userSlice"
import Loader from '../layouts/Loader';
import { MDBDataTable} from 'mdbreact';
import { toast, ToastContainer } from "react-toastify"; 
import Sidebar from './Sidebar/Sidebar';
import './Userlist.css';
import 'react-toastify/dist/ReactToastify.css'; 


export default function UserList() {
    const { users = [], loading = true, error, isUserDeleted }  = useSelector(state => state.userState)

    const dispatch = useDispatch();

    const setUsers = () => {
        const data = {
            columns : [
                {
                    label: 'Name',
                    field: 'name',
                    sort: 'asc'
                },
                {
                    label: 'Email',
                    field: 'email',
                    sort: 'asc'
                },
                {
                    label: 'Role',
                    field: 'role',
                    sort: 'asc'
                },
                {
                    label: 'Actions',
                    field: 'actions',
                    sort: 'asc'
                }
            ],
            rows : []
        }

        users.forEach( user => {
            data.rows.push({
                id: user._id,
                name: user.name,
                email : user.email,
                role: user.role ,
                actions: (
                    <Fragment className='fragment'>
                        <Link to={`/admin/user/${user._id}`}  className="btn btn-primary edit py-1 px-2 ml-2" > <i className="fa fa-pencil"></i></Link>
                       <br/>
                        <Button onClick={e => deleteHandler(e, user._id)} className="btn btn-danger py-1 px-2 ml-2 remove">
                            <i className="fa fa-trash"></i>
                        </Button>
                    </Fragment>
                )
            })
        })

        return data;
    }

    const deleteHandler = (e, id) => {
        e.target.disabled = true;
        dispatch(deleteUser(id))
    }

    useEffect(() => {
        if(error) {
            toast(error, {
                position: "bottom-center",
                type: 'error',
                onOpen: ()=> { dispatch(clearError()) }
            })
            return
        }
        if(isUserDeleted) {
            toast('User Deleted Succesfully!',{
                type: 'success',
                position: "bottom-center",
                onOpen: () => dispatch(clearUserDeleted())
            })
            return;
        }

        dispatch(getUsers)
    },[dispatch, error, isUserDeleted])


    return (
        <>
           <ToastContainer />
        <div className="admin">
         <Sidebar/>
        <div className="col-12 col-md-10">
            <h1 className="my-5">User List</h1>
            <Fragment>
                    {loading ? <Loader /> :
                        <div className="table-responsive">
                            <MDBDataTable
                                data={setUsers()}
                                bordered
                                striped
                                hover
                                className="px-3"
                            />
                        </div>
                    }
                </Fragment>
        </div>
    </div>
    </>
    )
}